import { Link } from "react-router-dom";

const LINKS = [
  { to: "/policy?tab=terms", label: "Terms", testid: "footer-terms" },
  { to: "/policy?tab=privacy", label: "Privacy", testid: "footer-privacy" },
  { to: "/policy?tab=community", label: "Community Guidelines", testid: "footer-community" },
  { to: "/delete-account", label: "Delete Account", testid: "footer-delete-account" },
];

export default function LegalFooter() {
  return (
    <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-testid="legal-footer">
      {LINKS.map(l => (
        <Link key={l.to} to={l.to} data-testid={l.testid} className="hover:text-[#00E5FF] underline underline-offset-2">{l.label}</Link>
      ))}
    </div>
  );
}
